<ng-container [ngSwitch]="true">
	<!-- BASIC DIALOG WITH ICON -->
	<ng-container *ngSwitchCase="!isMobile || kamonaDialogType === BASIC_VIEW">
		<div class="kamona-dialog">
			<div [ngClass]="{ 'pb-2': showIconOnDesktop }" class="flex flex-col justify-center items-center rounded-t-2xl">
				<div *ngIf="showIconOnDesktop" [ngClass]="className" class="kamona-dialog-header-icon">
					<ng-container *ngIf="!icon && dialogType; else icon">
						<ng-container *ngTemplateOutlet="mainIconsTpl"> </ng-container>
					</ng-container>
				</div>
				<ng-container [ngSwitch]="true">
					<ng-container *ngSwitchCase="kamonaDialogType === MOBILE_ALERT_VIEW">
						<div class="text-black font-bold text-lg text-center pt-[15px]">
							<ng-container *ngTemplateOutlet="titleTpl"></ng-container>
						</div>
					</ng-container>
					<ng-container *ngSwitchDefault>
						<div *ngIf="title" class="text-black font-bold text-lg text-center">{{ title | translate | titlecase }}</div>
					</ng-container>
				</ng-container>
			</div>
			<div class="bg-white rounded-b-2xl">
				<ng-container [ngSwitch]="true">
					<ng-container *ngSwitchCase="kamonaDialogType === MOBILE_ALERT_VIEW">
						<div class="text-center pb-6 max-w-xs mx-auto">
							<ng-container *ngTemplateOutlet="messageTpl"></ng-container>
							<ng-container *ngIf="dialogType === 'new-success'">
								<ng-container *ngTemplateOutlet="messageTpl2"></ng-container>
								<ng-container *ngTemplateOutlet="messageTpl3"></ng-container>

							</ng-container>
						</div>
						<div>
							<ng-container *ngTemplateOutlet="extraContentTpl"></ng-container>
						</div>
						<div class="kamona-alert-info-message-desktop">
							<ng-container *ngTemplateOutlet="extraMessageTpl"></ng-container>
						</div>
						<div *ngIf="dialogType !== 'processing'" class="border-[0.7px] border-primary opacity-[0.17]"></div>
						<div class="mt-auto px-6 pb-8 text-center">
							<ng-container *ngTemplateOutlet="actionTpl"></ng-container>
						</div>
					</ng-container>
					<ng-container *ngSwitchDefault>
						<ng-container *ngTemplateOutlet="mainContentTpl"></ng-container>
					</ng-container>
				</ng-container>
			</div>
		</div>
	</ng-container>

	<!--  BASIC DIALOG WITH ICON -->

	<!-- KAMONA DIALOG -->
	<ng-container *ngSwitchCase="isMobile && kamonaDialogType === MOBILE_VIEW">
		<div class="kamona-dialog">
			<div class="kamona-dialog-mobile-header text-center bg-no-repeat bg-cover bg-top origin-bottom bg-dialog">
				<div [ngClass]="className" class="flex p-[8px] justify-center kamona-dialog-mobile-header-icon">
					<ng-container *ngIf="!icon; else icon">
						<ng-container *ngTemplateOutlet="mainIconsTpl"></ng-container>
					</ng-container>
				</div>
				<div *ngIf="title" class="text-center text-2xl font-bold text-black">{{ title | translate | titlecase }}</div>
			</div>
			<div class="bg-white rounded-b-2xl rounded-none pt-4 pb-6 px-5">
				<ng-container *ngTemplateOutlet="mainContentTpl"></ng-container>
			</div>
		</div>
	</ng-container>
	<!--  KAMONA DIALOG -->

	<!-- KAMONA ALERT DIALOG -->
	<ng-container *ngSwitchCase="isMobile && kamonaDialogType === MOBILE_ALERT_VIEW">
		<div [ngClass]="dialogType" [ngClass]=" dialogType === 'error' ? 'bg-error-pattern' : 'bg-moniepoint-pattern' " class=" h-screen overflow-y-auto relative flex flex-col justify-end">
			<div class="flex flex-col justify-between min-h-screen">
				<div class="m-auto min-w-[327px] py-6 px-8 flex flex-col justify-center items-center text-center text-white">
					<div class="mb-10 w-fit">
						<ng-container *ngIf="!icon; else icon">
							<ng-container *ngTemplateOutlet="maximizeIconsTpl"></ng-container>
						</ng-container>
					</div>
					<div class="font-black text-2xl leading-7 max-w-xs mx-auto text-center">
						<ng-container *ngTemplateOutlet="titleTpl"></ng-container>
					</div>
					<div class="max-w-xs mx-auto mb-3" [class]="dialogType === 'new-success' ? 'text-left' : 'text-center'">
						<ng-container *ngTemplateOutlet="messageTpl"></ng-container>
						<ng-container *ngIf="dialogType === 'new-success'">
						<ng-container *ngTemplateOutlet="messageTpl2"></ng-container>
						<ng-container *ngTemplateOutlet="messageTpl3"></ng-container>
						</ng-container>
					</div>
					<div class="max-w-xs mx-auto text-center">
						<ng-container *ngTemplateOutlet="extraMessageTpl"></ng-container>
					</div>
					<div>
						<ng-container *ngTemplateOutlet="extraContentTpl"></ng-container>
					</div>
				</div>
				<div class="mt-auto px-6 pb-8 text-center">
					<ng-container *ngTemplateOutlet="actionTpl"></ng-container>
				</div>
			</div>
		</div>
	</ng-container>
	<!--  KAMONA ALERT DIALOG -->
</ng-container>

<ng-template #titleTpl>
	<ng-content select="[title]"></ng-content>
</ng-template>
<ng-template #messageTpl>
	<ng-content select="[message]"></ng-content>
</ng-template>
<ng-template #messageTpl2>
	<ng-content select="[message2]"></ng-content>
</ng-template>
<ng-template #messageTpl3>
	<ng-content select="[message3]"></ng-content>
</ng-template>
<ng-template #extraMessageTpl>
	<ng-content select="[extraMessage]"></ng-content>
</ng-template>
<ng-template #extraContentTpl>
	<ng-content select="[extraContent]"></ng-content>
</ng-template>
<ng-template #actionTpl>
	<ng-content select="[action]"></ng-content>
</ng-template>

<ng-template #mainContentTpl>
	<ng-content></ng-content>
</ng-template>

<ng-template #mainIconsTpl>
	<ng-container [ngSwitch]="true">
		<ng-container *ngSwitchCase="dialogType === 'confirm'">
			<svg fill="none" height="73" viewBox="0 0 73 73" width="73" xmlns="http://www.w3.org/2000/svg">
				<g clip-path="url(#clip0_14386_60340)">
					<circle cx="36.5" cy="36.5" fill="#F08922" fill-opacity="0.1" r="36.5" />
					<path
						d="M37 59C24.5736 59 14.5 48.9264 14.5 36.5C14.5 24.0736 24.5736 14 37 14C49.4264 14 59.5 24.0736 59.5 36.5C59.4864 48.9208 49.4208 58.9864 37 59ZM34.75 43.25V47.75H39.25V43.25H34.75ZM34.75 25.25V38.75H39.25V25.25H34.75Z"
						fill="#F08922"
					/>
				</g>
				<defs>
					<clipPath id="clip0_14386_60340">
						<rect fill="white" height="73" width="73" />
					</clipPath>
				</defs>
			</svg>
		</ng-container>
		<ng-container *ngSwitchCase="dialogType === 'info'">
			<svg fill="none" height="70" viewBox="0 0 73 74" xmlns="http://www.w3.org/2000/svg">
				<circle cx="36.5" cy="37" fill="#0357EE" fill-opacity="0.1" r="36.5" />
				<path
					d="M37 59.5C24.5736 59.5 14.5 49.4264 14.5 37C14.5 24.5736 24.5736 14.5 37 14.5C49.4264 14.5 59.5 24.5736 59.5 37C59.4864 49.4208 49.4208 59.4864 37 59.5ZM34.75 43.75V48.25H39.25V43.75H34.75ZM34.75 25.75V39.25H39.25V25.75H34.75Z"
					fill="#0361F0"
				/>
			</svg>
		</ng-container>
		<ng-container *ngSwitchCase="dialogType === 'success'">
			<svg fill="none" height="70" viewBox="0 0 69 68" xmlns="http://www.w3.org/2000/svg">
				<circle cx="34.5" cy="34" fill="#1EB12D" fill-opacity="0.1" r="34" />
				<circle cx="33.375" cy="32.875" fill="white" r="16.875" />
				<path
					d="M34.5 56.5C22.0792 56.4864 12.0136 46.4208 12 34V33.55C12.2473 21.1852 22.4278 11.3379 34.794 11.502C47.1602 11.6661 57.0758 21.78 56.995 34.147C56.9142 46.5141 46.8673 56.4976 34.5 56.5ZM25.7603 34.6592C24.8829 33.7852 23.4635 33.7865 22.5878 34.6623C21.7109 35.5392 21.7109 36.9609 22.5878 37.8378L27.5714 42.8215C28.9127 44.1627 31.0873 44.1627 32.4286 42.8215L46.4137 28.8363C47.2907 27.9593 47.2932 26.5383 46.4194 25.6582C45.5411 24.7737 44.1114 24.7712 43.23 25.6526L30.5183 38.3643C30.2319 38.6507 29.7677 38.6511 29.4807 38.3653L25.7603 34.6592Z"
					fill="#1EB12D"
				/>
			</svg>
		</ng-container>
		<ng-container *ngSwitchCase="dialogType === 'new-success'">
			<img src="assets/images/dialog-icon.svg" alt="">
		</ng-container>
		<ng-container *ngSwitchCase="dialogType === 'error'">
			<svg _ngcontent-yqn-c298="" fill="none" height="70" viewBox="0 0 68 68" width="68" xmlns="http://www.w3.org/2000/svg">
				<circle _ngcontent-yqn-c298="" cx="34" cy="34" fill="#E94444" fill-opacity="0.1" r="34"></circle>
				<path
					_ngcontent-yqn-c298=""
					d="M34 56.5C21.5736 56.5 11.5 46.4264 11.5 34C11.5 21.5736 21.5736 11.5 34 11.5C46.4264 11.5 56.5 21.5736 56.5 34C56.4864 46.4208 46.4208 56.4864 34 56.5ZM31.75 40.75V45.25H36.25V40.75H31.75ZM31.75 22.75V36.25H36.25V22.75H31.75Z"
					fill="#E94444"
				></path>
			</svg>
		</ng-container>
		<ng-container *ngSwitchCase="dialogType === 'filter'">
			<svg fill="none" height="73" viewBox="0 0 73 73" width="73" xmlns="http://www.w3.org/2000/svg">
				<g clip-path="url(#clip0_315_11391)">
					<circle cx="36.5" cy="36.5" fill="#0357EE" fill-opacity="0.1" r="36.5" />
					<path
						d="M39.125 53.25C38.9245 53.2499 38.7253 53.2174 38.5351 53.1539L32.2734 51.0703C31.901 50.9452 31.5776 50.7059 31.3489 50.3864C31.1203 50.0669 30.9982 49.6835 31 49.2906V39.9773C30.9983 39.9736 30.9959 39.9701 30.9929 39.9672L17.8172 24.6203C17.525 24.28 17.3367 23.8629 17.2745 23.4187C17.2123 22.9745 17.2789 22.5217 17.4663 22.1142C17.6538 21.7067 17.9543 21.3616 18.332 21.1198C18.7098 20.8779 19.1491 20.7496 19.5976 20.75H52.4062C52.8548 20.7496 53.294 20.8779 53.6718 21.1198C54.0496 21.3616 54.3501 21.7067 54.5375 22.1142C54.725 22.5217 54.7916 22.9745 54.7294 23.4187C54.6672 23.8629 54.4789 24.28 54.1867 24.6203L41.007 39.9688C41.0043 39.9719 41.002 39.9753 41 39.9789V51.375C41.0007 51.6214 40.9527 51.8656 40.8587 52.0934C40.7647 52.3212 40.6267 52.5282 40.4524 52.7024C40.2782 52.8767 40.0712 53.0148 39.8434 53.1087C39.6155 53.2027 39.3714 53.2507 39.125 53.25Z"
						fill="#0361F0"
					/>
				</g>
				<defs>
					<clipPath id="clip0_315_11391">
						<rect fill="white" height="73" width="73" />
					</clipPath>
				</defs>
			</svg>
		</ng-container>
		<ng-container *ngSwitchCase="dialogType === 'filter-bordered'">
			<div class="filter-bordered" nz-row nzAlign="middle" nzJustify="center">
				<img alt="funnel" src="assets/images/svgs/funnel.svg" />
			</div>
		</ng-container>
		<ng-container *ngSwitchCase="dialogType === 'warning'">
			<svg fill="none" height="68" viewBox="0 0 68 68" width="68" xmlns="http://www.w3.org/2000/svg">
				<circle cx="34" cy="34" fill="#E94444" fill-opacity="0.1" r="34" />
				<path
					d="M34 56.5C21.5736 56.5 11.5 46.4264 11.5 34C11.5 21.5736 21.5736 11.5 34 11.5C46.4264 11.5 56.5 21.5736 56.5 34C56.4864 46.4208 46.4208 56.4864 34 56.5ZM31.75 40.75V45.25H36.25V40.75H31.75ZM31.75 22.75V36.25H36.25V22.75H31.75Z"
					fill="#E94444"
				/>
			</svg>
		</ng-container>
		<ng-container *ngSwitchCase="dialogType === 'sort'">
			<svg fill="none" height="73" viewBox="0 0 73 73" width="73" xmlns="http://www.w3.org/2000/svg">
				<g clip-path="url(#clip0_213_23376)">
					<circle cx="36.5" cy="36.5" fill="#0357EE" fill-opacity="0.1" r="36.5" />
					<path
						d="M29.0726 26.3918L22.3936 33.0708C21.8666 33.5978 21.8689 34.4544 22.3986 34.9841C22.9283 35.5138 23.7849 35.516 24.3118 34.9891L28.6873 30.6136L28.7237 44.5668C28.7256 45.314 29.3329 45.9213 30.0801 45.9232C30.8273 45.9252 31.4314 45.3211 31.4295 44.5739L31.3931 30.6206L35.7914 35.019C36.3212 35.5487 37.1778 35.5509 37.7047 35.024C38.2317 34.497 38.2294 33.6404 37.6997 33.1107L30.9858 26.3968C30.4561 25.8671 29.5995 25.8649 29.0726 26.3918Z"
						fill="#0361F0"
					/>
					<path
						d="M43.726 47.7229L50.405 41.0439C50.932 40.5169 50.9297 39.6603 50.4 39.1306C49.8703 38.6009 49.0137 38.5987 48.4867 39.1256L44.1112 43.5011L44.0749 29.5479C44.0729 28.8007 43.4657 28.1934 42.7185 28.1915C41.9713 28.1895 41.3672 28.7936 41.3691 29.5408L41.4055 43.4941L37.0071 39.0957C36.4774 38.566 35.6208 38.5638 35.0939 39.0907C34.5669 39.6177 34.5691 40.4743 35.0988 41.004L41.8127 47.7179C42.3424 48.2476 43.199 48.2498 43.726 47.7229Z"
						fill="#0361F0"
					/>
				</g>
				<defs>
					<clipPath id="clip0_213_23376">
						<rect fill="white" height="73" width="73" />
					</clipPath>
				</defs>
			</svg>
		</ng-container>
		<ng-container *ngSwitchCase="dialogType === 'processing'">
			<div class="p-b-30 p-t-20">
				<ng-container>
					<app-loading [parentHeight]="'40'" [size]="40"> </app-loading>
				</ng-container>
			</div>
		</ng-container>
		<ng-container *ngSwitchDefault>
			<svg fill="none" height="70" viewBox="0 0 73 74" xmlns="http://www.w3.org/2000/svg">
				<circle cx="36.5" cy="37" fill="#0357EE" fill-opacity="0.1" r="36.5" />
				<path
					d="M37 59.5C24.5736 59.5 14.5 49.4264 14.5 37C14.5 24.5736 24.5736 14.5 37 14.5C49.4264 14.5 59.5 24.5736 59.5 37C59.4864 49.4208 49.4208 59.4864 37 59.5ZM34.75 43.75V48.25H39.25V43.75H34.75ZM34.75 25.75V39.25H39.25V25.75H34.75Z"
					fill="#0361F0"
				/>
			</svg>
		</ng-container>
	</ng-container>
</ng-template>

<ng-template #maximizeIconsTpl>
	<ng-container [ngSwitch]="true">
		<ng-container *ngSwitchCase="dialogType === 'success'">
			<svg fill="none" height="113" viewBox="0 0 140 113" width="140" xmlns="http://www.w3.org/2000/svg">
				<ellipse cx="67.7527" cy="55.376" fill="url(#paint0_linear_4563_210693)" rx="55.6536" ry="55.376" />
				<g filter="url(#filter0_d_4563_210693)">
					<path
						clip-rule="evenodd"
						d="M59.4063 64.6107L44.553 50.2385L37.2988 57.4566L55.2034 75.2719C55.3131 75.4057 55.4305 75.5352 55.5559 75.6599C55.6812 75.7846 55.8114 75.9015 55.9458 76.0106L56.6434 76.7047L56.7781 76.5607C58.7168 77.5851 61.177 77.2848 62.8101 75.6599L98.2018 40.4447L94.8803 37.1397C92.7083 34.9786 89.1869 34.9786 87.0149 37.1397L59.4063 64.6107Z"
						fill="white"
						fill-rule="evenodd"
					/>
				</g>
				<path
					d="M126.639 16.2726L130.781 14.846C131.081 14.7465 131.081 14.2488 130.781 14.1493L126.639 12.7227C126.533 12.6895 126.455 12.601 126.426 12.4794L125.178 7.75712C125.091 7.41429 124.655 7.41429 124.568 7.75712L123.32 12.4794C123.291 12.601 123.213 12.6895 123.107 12.7227L118.975 14.1493C118.675 14.2488 118.675 14.7465 118.975 14.846L123.117 16.2726C123.223 16.3058 123.3 16.3943 123.33 16.5159L124.578 21.2493C124.665 21.5921 125.1 21.5921 125.187 21.2493L126.436 16.5159C126.455 16.3943 126.533 16.3058 126.639 16.2726Z"
					fill="#ECAB03"
				/>
				<path
					d="M5.77681 32.6739L8.80959 31.6292C9.02925 31.5563 9.02925 31.1919 8.80959 31.119L5.77681 30.0744C5.69886 30.0501 5.64218 29.9853 5.62092 29.8962L4.70683 26.4383C4.64306 26.1872 4.32419 26.1872 4.26042 26.4383L3.34633 29.8962C3.32507 29.9853 3.26839 30.0501 3.19044 30.0744L0.164748 31.119C-0.054916 31.1919 -0.054916 31.5563 0.164748 31.6292L3.19753 32.6739C3.27547 32.6982 3.33216 32.763 3.35342 32.8521L4.2675 36.3181C4.33128 36.5691 4.65015 36.5691 4.71392 36.3181L5.628 32.8521C5.64218 32.763 5.69886 32.6982 5.77681 32.6739Z"
					fill="#ECAB03"
				/>
				<path
					d="M19.4552 105.654L25.0753 103.718C25.4824 103.583 25.4824 102.908 25.0753 102.773L19.4552 100.837C19.3107 100.792 19.2057 100.672 19.1663 100.507L17.4724 94.0989C17.3542 93.6337 16.7633 93.6337 16.6451 94.0989L14.9512 100.507C14.9118 100.672 14.8067 100.792 14.6623 100.837L9.0553 102.773C8.64823 102.908 8.64823 103.583 9.0553 103.718L14.6754 105.654C14.8199 105.699 14.9249 105.819 14.9643 105.984L16.6582 112.407C16.7764 112.873 17.3673 112.873 17.4855 112.407L19.1794 105.984C19.2057 105.819 19.3107 105.699 19.4552 105.654Z"
					fill="#ECAB03"
				/>
				<defs>
					<filter
						color-interpolation-filters="sRGB"
						filterUnits="userSpaceOnUse"
						height="51.5248"
						id="filter0_d_4563_210693"
						width="70.7917"
						x="32.3544"
						y="35.5189"
					>
						<feFlood flood-opacity="0" result="BackgroundImageFix" />
						<feColorMatrix
							in="SourceAlpha"
							result="hardAlpha"
							type="matrix"
							values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						/>
						<feOffset dy="4.94444" />
						<feGaussianBlur stdDeviation="2.47222" />
						<feComposite in2="hardAlpha" operator="out" />
						<feColorMatrix type="matrix" values="0 0 0 0 0.0868924 0 0 0 0 0.595833 0 0 0 0 0.348739 0 0 0 1 0" />
						<feBlend in2="BackgroundImageFix" mode="normal" result="effect1_dropShadow_4563_210693" />
						<feBlend in="SourceGraphic" in2="effect1_dropShadow_4563_210693" mode="normal" result="shape" />
					</filter>
					<linearGradient
						gradientUnits="userSpaceOnUse"
						id="paint0_linear_4563_210693"
						x1="67.7527"
						x2="67.7525"
						y1="-28.7955"
						y2="89.7092"
					>
						<stop stop-color="#D0DB51" />
						<stop offset="1" stop-color="#17A25F" />
					</linearGradient>
				</defs>
			</svg>
		</ng-container>
		<ng-container *ngSwitchCase="dialogType === 'new-success'">
			
			<img src="assets/images/issue-logged-mobile.svg" alt="">
		</ng-container>
		<ng-container *ngSwitchCase="dialogType === 'error'">
			<svg fill="none" height="113" viewBox="0 0 142 113" width="142" xmlns="http://www.w3.org/2000/svg">
				<ellipse cx="68.7523" cy="55.38" fill="url(#paint0_linear_4563_212671)" rx="55.6576" ry="55.38" />
				<g filter="url(#filter0_d_4563_212671)">
					<path
						clip-rule="evenodd"
						d="M49.2877 37.0852C47.4804 39.1325 47.6749 42.2573 49.7222 44.0647L62.6958 55.5179L47.9702 72.1984L51.6772 75.4709C53.7245 77.2783 56.8493 77.0838 58.6567 75.0365L70.1097 62.0629L86.7919 76.79L90.0644 73.083C91.8718 71.0357 91.6773 67.9109 89.63 66.1035L76.6548 54.649L91.3819 37.9667L87.675 34.6942C85.6277 32.8869 82.5028 33.0814 80.6955 35.1287L69.2409 48.1039L52.5602 33.3783L49.2877 37.0852Z"
						fill="white"
						fill-rule="evenodd"
					/>
				</g>
				<defs>
					<filter
						color-interpolation-filters="sRGB"
						filterUnits="userSpaceOnUse"
						height="53.3013"
						id="filter0_d_4563_212671"
						width="53.3012"
						x="43.0254"
						y="33.3783"
					>
						<feFlood flood-opacity="0" result="BackgroundImageFix" />
						<feColorMatrix
							in="SourceAlpha"
							result="hardAlpha"
							type="matrix"
							values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						/>
						<feOffset dy="4.9448" />
						<feGaussianBlur stdDeviation="2.4724" />
						<feComposite in2="hardAlpha" operator="out" />
						<feColorMatrix type="matrix" values="0 0 0 0 0.85 0 0 0 0 0.223125 0 0 0 0 0.223125 0 0 0 1 0" />
						<feBlend in2="BackgroundImageFix" mode="normal" result="effect1_dropShadow_4563_212671" />
						<feBlend in="SourceGraphic" in2="effect1_dropShadow_4563_212671" mode="normal" result="shape" />
					</filter>
					<linearGradient
						gradientUnits="userSpaceOnUse"
						id="paint0_linear_4563_212671"
						x1="98.6543"
						x2="24.4823"
						y1="111.258"
						y2="-26.5783"
					>
						<stop stop-color="#E94444" />
						<stop offset="1" stop-color="#F98484" />
					</linearGradient>
				</defs>
			</svg>
		</ng-container>
		<ng-container *ngSwitchCase="dialogType === 'warning'">
			<svg fill="none" height="68" viewBox="0 0 68 68" width="68" xmlns="http://www.w3.org/2000/svg">
				<circle cx="34" cy="34" fill="#E94444" fill-opacity="0.1" r="34" />
				<path
					d="M34 56.5C21.5736 56.5 11.5 46.4264 11.5 34C11.5 21.5736 21.5736 11.5 34 11.5C46.4264 11.5 56.5 21.5736 56.5 34C56.4864 46.4208 46.4208 56.4864 34 56.5ZM31.75 40.75V45.25H36.25V40.75H31.75ZM31.75 22.75V36.25H36.25V22.75H31.75Z"
					fill="#E94444"
				/>
			</svg>
		</ng-container>
		<ng-container *ngSwitchCase="dialogType === 'processing'">
			<app-loading [parentHeight]="'88'" [size]="88" [strokeOpacity]="'.1'" [stroke]="'#FFFFFF'"> </app-loading>
		</ng-container>
	</ng-container>
</ng-template>
